import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import StoryWorkspace from "@/pages/StoryWorkspace";
import ManifestReview from "@/pages/ManifestReview";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/stories/:storyId" element={<StoryWorkspace />} />
            <Route path="/stories/:storyId/manifest" element={<ManifestReview />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
